import types from './types';

const setExtent = extent => ({
  type: types.SET_EXTENT,
  payload: {
    extent
  }
});

const mapLoaded = () => ({
  type: types.MAP_LOADED,
  payload: {}
});

const setMapColumnVisible = mapColumnVisible => ({
  type: types.MAP_COLUMN_VISIBLE,
  payload: {
    mapColumnVisible
  }
});

export default {
  setExtent,
  mapLoaded,
  setMapColumnVisible
};



// WEBPACK FOOTER //
// ./src/redux/map/actions.js